import React, { useEffect, useState } from 'react';
import { Grid, IconButton } from '@mui/material';
import AddIcon from '@mui/icons-material/Add';
import DeleteIcon from '@mui/icons-material/Delete';
import UserForm from './UserForm';
import UserPicker from './UserPicker';
import UserDetailsDialog from './UserDetailsDialog';

const AssayAccess = ({ inputConfig, onChange }) => {
    const [config, setConfig] = useState({
        approved_users: [],
        assay_name: '',
        config_directory: '',
        status: 'NEW',
        config_type: '',
        cro_contact: '',
        data_file_cro: '',
        data_file_program: '',
        labels: '',
        plugin: 'acas_assay',
        preprocessor: 'standard_preprocessor',
        validator: 'standard_validator',
        loader: 'standard_loader',
        point_of_contact_id: '',
        provider_organization_id: '',
        issue_program_id: '',
    });

    const [organizationFilter, setOrganizationFilter] = useState(null)
    const [newUserDetailsDialogUser, setNewUserDetailsDialogUser] = useState(null)
    const [isUserDetailsDialogOpen, setIsUserDetailsDialogOpen] = useState(null)

    useEffect(() => {
        if (inputConfig) {
            setConfig(inputConfig);
        }

        console.dir("Assay Access useEffect")
        console.dir(inputConfig)
        console.dir(inputConfig["provider_organization_id"])

        setOrganizationFilter(inputConfig["provider_organization_id"])

    }, [inputConfig]);

    const handleUserChange = (index, updatedUser) => {
        const updatedUsers = [...config.approved_users];
        updatedUsers[index] = updatedUser;
        const updatedConfig = { ...config, approved_users: updatedUsers };
        setConfig(updatedConfig);
        onChange(updatedConfig);
    };

    const handleAddNewUser = (e, resultingUser) => {
        const updatedConfig = { ...config, approved_users: [...config.approved_users, resultingUser] };
        setConfig(updatedConfig);
        onChange(updatedConfig);
        closeAddUserDialog();
    };


    const handleAddExistingUser = (newUserId, newUser) => {
        console.dir("Assay Access");
        console.dir("handleAddExistingUser:" + newUser);
        const updatedConfig = { ...config, approved_users: [...config.approved_users, newUser] };
        setConfig(updatedConfig);
        onChange(updatedConfig);
    };


    const handleDeleteUser = (index) => {
        const updatedUsers = config.approved_users.filter((_, i) => i !== index);
        const updatedConfig = { ...config, approved_users: updatedUsers };
        setConfig(updatedConfig);
        onChange(updatedConfig);
    };

    const openAddUserDialog = () => {
        const newUser = { username: '', email: '', first_name: '', last_name: '', type: 'depositor', organization_id: organizationFilter };
        setNewUserDetailsDialogUser(newUser);
        setIsUserDetailsDialogOpen(true);
    }

    const closeAddUserDialog = () => {
        setIsUserDetailsDialogOpen(false);
        setNewUserDetailsDialogUser(null);
    }





    return (
        <div style={{ padding: '20px', margin: '20px', minHeight: '300px' }}>
            <h3>Manage Access - Step 2</h3>

            <Grid container spacing={2}>
                {config.approved_users.map((user, index) => (
                    <Grid item xs={12} key={index}>
                        <Grid container spacing={2} alignItems="center">
                            <Grid item xs={11}>
                                <UserForm
                                    inputEntity={user}
                                    onChange={(updatedUser) => handleUserChange(index, updatedUser)}
                                    isDisabled={true}
                                    showOrganization={false}
                                    showUserType={false}
                                    showUsername={false}
                                />
                            </Grid>
                            <Grid item xs={1}>
                                <IconButton onClick={() => handleDeleteUser(index)}>
                                    <DeleteIcon />
                                </IconButton>
                            </Grid>
                        </Grid>
                    </Grid>
                ))}

                <Grid item xs={6}>
                    <UserPicker onSelect={handleAddExistingUser} orgIdFilter={organizationFilter} />
                </Grid>
                <Grid item xs={1}>
                    <IconButton style={{ backgroundColor:"#282c34", color:"white", margin:"6px", fontSize:"28px", fontWeight:"bold" }} onClick={openAddUserDialog}>
                        <AddIcon />
                    </IconButton>
                </Grid>
            </Grid>
            <UserDetailsDialog inputEntity={newUserDetailsDialogUser} open={isUserDetailsDialogOpen} onClose={closeAddUserDialog} onSubmit={handleAddNewUser} showOrganization={false}
                                    showUserType={false} showUsername={false} />
        </div>
    );
};

export default AssayAccess;
